const image1 = 'https://oss.turingsenseai.com/15940928277274.png'
const image2 = 'https://oss.turingsenseai.com/15940928785808.png'
const image3 = 'https://oss.turingsenseai.com/15940928935740.png'
const image4 = 'https://oss.turingsenseai.com/15940929036333.png'
const image5 = 'https://oss.turingsenseai.com/15940929133946.png'
const image6 = 'https://oss.turingsenseai.com/15940930111150.png'
const image7 = 'https://oss.turingsenseai.com/1594092926853.png'
const content = `
<style type="text/css">.custom-image { margin-top: 10px }</style>
<p class="ql-align-center">
</p>
<p class="ql-align-center">
  <br>
</p>


<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
1.&nbsp;包身：将包置于无杂物、光线充足的背景中，完整拍摄正面、背面、底面、侧面的任一一面（如有瑕疵，请拍摄瑕疵最明显的一面），请确保包身居于画面中央、无遮挡、在整个画面中占比大一些；
</p>
<p class="ql-align-center">
  <img calss="custom-image" src="${image1}">
</p>
<br>
<p class="ql-align-justify">
2.&nbsp;边角：请拍摄包底、包口、侧边缘任一边角（如有瑕疵，请拍摄瑕疵最明显的一处边角）请确保边角在画面中占比至少1/3，瑕疵处清晰无遮挡；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image2}">
</p>
<br>
<p class="ql-align-justify">
3.&nbsp;提手/配饰：请拍摄提手或配饰，如有瑕疵，请拍摄瑕疵最明显的一处。确保主体在整个画面中占比至少1/3，无其他杂物；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image3}">
</p>
<p class="ql-align-center">
  <br>
</p>
<p class="ql-align-justify">
4.&nbsp;里衬：请撑开包袋（钱包展开即可），拍摄包内，如有瑕疵，请拍摄瑕疵最明显的一处；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image4}">
<img calss="custom-image" src="${image5}">
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
5.&nbsp;五金：请靠近五金（锁扣、拉链、铆钉、搭扣等）清晰拍摄，如有瑕疵，请拍摄瑕疵最明显的一处，确保主体在整个画面中占比至少1/3，避免反光和倒影；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image6}">
</p>
<br />
<p class="ql-align-justify">
6.&nbsp;其他明显瑕疵处：除以上部分，如果包袋还有磨损、染色、掉色、水渍、褶皱、开裂、断裂、变形、划痕、断线等非商品原始状态的瑕疵，请清晰完整拍摄明显的瑕疵部分。
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image7}">
</p>
<br />
<p>
  <br>
</p>
`
export default {
  content,
  title: '成色识别拍摄说明'
}
